import ResidentDashboard from './ResidentDashboard.component';
export default ResidentDashboard;
